export default __webpack_public_path__ + "static/media/ic_smart_home.512f0d7a.jpg";